import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';
import { convertToIST } from 'utils/formtaDate';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from '../constants/url-constants';

const PrintCard = () => {

    const getAgeGroup = (age) => {
        if (age === "----") return { label: 'N/A', color: 'text-muted-foreground' };
        if (age < 25) return { label: 'Youth', color: 'text-success' };
        if (age < 45) return { label: 'Adult', color: 'text-primary' };
        if (age < 65) return { label: 'Senior', color: 'text-warning' };
        return { label: 'Elder', color: 'text-muted-foreground' };
    };

    const [member, setMember] = useState({});
    const [gLeader, setGLeader] = useState({});
    const [currentBatch,setCurrentBatch] = useState({});    

    useEffect(() => {
        const memberData = sessionStorage.getItem("pMember");
        if (memberData) {
            setMember(JSON.parse(memberData));
        }

        const gLeaderData = sessionStorage.getItem("pGLeader");

        if (gLeaderData) {
            setGLeader(JSON.parse(gLeaderData));
        }

        const batchData = sessionStorage.getItem("pCurrentBatch");

        if (batchData) {
            setCurrentBatch(JSON.parse(batchData));
        }   

        // Auto print after render
        // setTimeout(() => window.print(), 500);
    }, []);

    // const convertToIST = (date) => {

    //     if (!date) return "----";

    //     const dateString = date.split('T')[0]; // Get only the date part
    //     const [year, month, day] = dateString.split('-');
    //     return `${day}-${month}-${year}`;


    // }

    const onPreviewClick = async () => {
        const body = {
            batchId : currentBatch?._id,
            memberId : member?.id,
        }
        await httpHelper(URL_CONSTANTS.UPDATE_PRINT_STATUS, Method_TYPE.PUT, body);
        window.print()
         
    }

    return (
        <div className="regtn-container-pv">
            <div className="form-wrapper reg-form">
                <div className="form-header bold">
                    <h2>Print Preview</h2>
                </div>
                <form className="print" id="print-view">
                    {/* Header */}
                    <div className="print-hdr-div">
                        <span className="text-black font-bold">
                            {/* Period : <span id="periodName">{currentBatch?.period?.name}</span> | */}
                            Batch :
                            <span id="batchName" className="ml-1">{currentBatch?.name}</span> 
                           (<span id="batchStart">{convertToIST(currentBatch?.startDate)}</span> to{" "}
                            <span id="batchEnd">{convertToIST(currentBatch?.endDate)}</span>)
                        </span>
                    </div>

                    {/* Member Details Table */}
                    <table className="print-table-cont w-full mt-2">
                        <tbody>
                            <tr>
                                <td className="td-pad">
                                    <table className="margin-tab-first w-full">
                                        <tbody>
                                            <tr>
                                                {/* <td width="100" className="td-pad text-black">Name</td> */}
                                                <td className="td-pad text-black" id="memberName"><strong>{member.name}</strong></td>
                                            </tr>
                                            <tr>
                                                <td className="td-wd-first text-black">Seva Point : {member.servicePoint}</td>
                                                {/* <td className="text-black" id="sectorName">{member.servicePoint}</td> */}
                                            </tr>
                                            <tr>
                                                <td className="td-wd-first text-black">Mob No : {member.mobNo}</td>
                                                {/* <td className="text-black" id="leaderName">{member.mobNo}</td> */}
                                            </tr>
                                            <tr>
                                                <td className="td-wd-first text-black">District : {member.district}</td>
                                                {/* <td className="text-black" id="districtName">{member.district}</td> */}
                                            </tr>
                                            <tr>
                                                <td className="td-wd-first text-black">Samithi : {member.samithi}</td>
                                                {/* <td className="text-black" id="samithiName">{member.samithi}</td> */}
                                            </tr>
                                            <tr>
                                                <td className="td-wd-first text-black">Sai Connect : {member.saiOneId || "-----"}</td>
                                                {/* <td className="text-black" id="saiConnect">{member.saiOneId || "-----"}</td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            {/* Secondary Info */}
                            <tr>
                                <td style={{ paddingTop: '3%' }}>
                                    <table className="margin-tab-second w-full">
                                        <tbody>
                                            <tr>
                                                <td className="text-black td-wd">Blood Group</td>
                                                <td className="text-black" id="bloodGroup">{member.bloodGroup || "------"}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-black td-wd">Age</td>
                                                <td className="text-black" id="age">  {member.age} years</td>
                                            </tr>
                                            <tr>
                                                <td  className="text-black td-wd">Leader 1</td>
                                                <td  className="text-black" id="leader1Name">{gLeader?.leader1?.name || '-------' }</td>
                                                {/* <td width="100" className="text-black">Mob No</td>
                                                <td width="100" className="text-black" id="leader1Mob">{gLeader?.leader1?.mobNoPrimary || '-------'}</td> */}
                                            </tr>
                                            <tr>
                                                <td  className="text-black td-wd">L1 MobNo</td>
                                                <td  className="text-black" id="leader1Mob">{gLeader?.leader1?.mobNoPrimary || '-------'}</td> 
                                            </tr>
                                            <tr>
                                                <td className="text-black td-wd">Leader 2</td>
                                                <td className="text-black" id="leader2Name">{gLeader?.leader2?.name || '-------' }</td>
                                                {/* <td width="100" className="text-black">Mob No</td>
                                                <td width="100" className="text-black" id="leader2Mob">{gLeader?.leader2?.mobNoPrimary || '-------'}</td> */}
                                            </tr>
                                            <tr>
                                                <td  className="text-black td-wd">L2 MobNo</td>
                                                <td  className="text-black" id="leader2Mob">{gLeader?.leader2?.mobNoPrimary || '-------'}</td>  
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>

                <div id="footer-cont" className="form-footer">
                    <Button className='inline-flex md:h-full mr-4 w-36 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input hover:bg-gray-500 hover:text-white text-white rounded-md bg-gray-400 px-3'
                        variant="default"
                        iconName="Close"
                        onClick={() => window.close()}
                    >
                        Close
                    </Button>
                    <Button  className='hover:text-accent-foreground w-36 max-w-32 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2'
                        variant="default"
                        onClick={onPreviewClick}
                        iconName="Print"
                        iconPosition="left"
                    >
                        Print Card
                    </Button>
                    {/* <button id="print-btn" className="btn-success" onclick="window.print()">Print</button>
                    <button id="cancel-btn" className="btn-danger" onclick="alert('Cancelled!')">Cancel</button> */}
                </div>
            </div>
        </div>
    );
};

export default PrintCard;
